import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { RestrictedFooter } from '@opengovsg/design-system-react'

import {
  ADMIN_FEEDBACK_FORMSG_LINK,
  ADMIN_FEEDBACK_FORMSG_URL_FIELD_ID,
  APP_NAME,
  getPrefilledFeedbackFormUrl,
  PUBLIC_FEEDBACK_FORMSG_LINK,
  PUBLIC_FEEDBACK_FORMSG_URL_FIELD_ID,
} from '~/constants/config'

const FOOTER_LINKS = [
  {
    label: 'Privacy',
    href: '/privacy',
  },
  {
    label: 'Terms of Use',
    href: '/terms',
  },
  {
    label: 'Report Vulnerability',
    href: 'https://www.tech.gov.sg/report_vulnerability',
  },
]

export const Footer = () => {
  const { pathname, search } = useLocation()
  const feedbackUrl = useMemo(() => {
    // Trailing slash to guard against the off-chance that we have some
    // nanoid that starts with admin. We dont render the Footer on the
    // login page, but we still include it in the check to avoid surprises
    // if we ever do render it there.
    const isAdminRoute =
      pathname.startsWith('/admin/') && pathname !== '/admin/login'

    const formLink = isAdminRoute
      ? ADMIN_FEEDBACK_FORMSG_LINK
      : PUBLIC_FEEDBACK_FORMSG_LINK
    const urlFieldId = isAdminRoute
      ? ADMIN_FEEDBACK_FORMSG_URL_FIELD_ID
      : PUBLIC_FEEDBACK_FORMSG_URL_FIELD_ID

    return getPrefilledFeedbackFormUrl({ formLink, urlFieldId })

    // We want to update on both path change and query string change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, search])
  return (
    <RestrictedFooter
      appLink={window.location.origin}
      appName={APP_NAME.full}
      containerProps={{
        bgColor: 'base.canvas.alt',
      }}
      footerLinks={[
        {
          label: 'Feedback',
          href: feedbackUrl,
        },
        ...FOOTER_LINKS,
      ]}
    />
  )
}
